<template>
  <div class="d-flex justify-start mt-10 mb-5">
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
export default {
  props: [
    'title'
  ]
}
</script>
